import React from 'react';
import Slider from 'react-slick';
import ProductMainVideo from '../ProductMainImage/ProductMainVideo';
import { shouldMock } from '../../../../../../util/mockProduct';

class AltImages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlts: false,
      siteFormat: this.props.passedAppFunctions ? this.props.passedAppFunctions.siteFormat : '',
      nav: null,
    };

    this.lazyLoadDesktopAlts = this.lazyLoadDesktopAlts.bind(this);
  }

  componentDidMount() {
    this.setState({ showAlts: true });
    this.setState({ nav: this.altSlider });
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
    if (
      this.props.passedAppFunctions.siteFormat == 'desktop' &&
      this.props.passedAppFunctions.quickviewIsOpen == false &&
      this.props.contentData.altImages
    ) {
      this.lazyLoadDesktopAlts();
    }
  }
  componentDidUpdate(prevProps) {
    // if (this.altSlider && this.colorSelected) {
    // 	// this.altSlider.innerSlider.resizeWindow();
    // 	console.log(this.props.altIndex)
    // 	// this.altSlider.slickGoTo(this.props.altIndex);
    // }

    if (document.querySelector('#product-alt-wrapper .scrollAlts')) {
      //get index of selected boi
      if (!this.props.altClicked && document.querySelector('#product-alt-wrapper .scrollAlts .topAltImage')) {
        var index = document.querySelector('#product-alt-wrapper .scrollAlts .topAltImage').getAttribute('data-index');
        document.querySelector('#product-alt-wrapper .scrollAlts').scrollTop = index * 117;
      }
      this.lazyLoadDesktopAlts();
    }
    if (prevProps.contentData.productId && prevProps.contentData.productId !== this.props.contentData.productId) {
      if (
        this.props.passedAppFunctions.siteFormat == 'desktop' &&
        this.props.passedAppFunctions.quickviewIsOpen == false &&
        this.props.contentData.altImages
      ) {
        this.lazyLoadDesktopAlts();
      }
    }
  }

  lazyLoadDesktopAlts() {
    var altImgCount = Object.keys(this.props.contentData.altImages);
    if (altImgCount.length > 5) {
      if (window.IntersectionObserver) {
        if (lazyAltObserver) {
          lazyAltObserver.disconnect();
        }
        var rootElement = document.querySelector('.scrollAlts');
        var options = {
          root: rootElement,
          rootMargin: '0px',
          threshold: 0,
        };
        var lazyAltObserver = new IntersectionObserver((entries, lazyAltObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !entry.target.classList.contains('already-loaded')) {
              entry.target.src = entry.target.dataset.original;
              entry.target.classList.add('already-loaded');
              lazyAltObserver.unobserve(entry.target);
            }
          });
        }, options);
        document.querySelectorAll('.lazy-altImage').forEach((lazyAlt) => {
          lazyAltObserver.observe(lazyAlt);
        });
        setTimeout(function () {
          if (document.querySelector('.scrollAlts') !== null) {
            document.querySelector('.scrollAlts').style.visibility = 'visible';
          }
        }, 600);
      }
    } else {
      if (altImgCount.length <= 5 && document.querySelector('.scrollAlts') !== null) {
        document.querySelector('.scrollAlts').style.visibility = 'visible';
      }
    }
  }

  render() {
    this.color = '';
    this.colorSelected = false;
    this.shouldFilter = false;
    this.shrinkButton = false;
    var altImagesToUse = this.props.passedFunctions.parentState.productImagesArray;

    var vertical = this.state.siteFormat == 'desktop' ? true : false,
      arrows = (altImagesToUse || []).length > 4,
      slidesToShow = 4;

    if (this.state.siteFormat == 'tablet' || this.state.siteFormat == 'mobile') {
      // If Vertical is set to false and you are using a tablet device
      if (this.props.vertical !== undefined && !this.props.vertical) {
        arrows = false;
        slidesToShow =
          this.state.siteFormat == 'tablet' &&
          (this.props.contentData.productLayout == 'BundleDisplay' ||
            this.props.contentData.productLayout == 'OutfitDisplay')
            ? 2.5
            : 3.5;
        vertical = false;
      }
    }

    var settings = {
      dots: false,
      infinite: false,
      vertical: vertical,
      speed: 500,
      slidesToShow: slidesToShow,
      swipeToSlide: true,
      swipe: true,
      lazyLoad: true,
      lazyLoadBuffer: 1,
      arrows: arrows,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: this.props.qvSlidesToShow || slidesToShow,
            swipeToSlide: true,
            vertical: this.props.qvAlt || false,
            arrows: this.props.qvAlt || false,
          },
        },
      ],
    };

    if (this.props.passedFunctions.parentState.currentAttributeState?.Color?.attrName == 'Color') {
      if (this.props.passedFunctions.parentState.currentAttributeState.Color.selectedValue !== undefined) {
        this.colorSelected = true;
      }
    }

    // var res;
    if (this.props.selectedMainImg && this.altSlider && altImagesToUse) {
      for (var i = 0; i < altImagesToUse.length; i++) {
        if (altImagesToUse[i].imageName === this.props.selectedMainImg) {
          if (this.props.contentData?.dept?.indexOf('00') == '00') {
            this.shouldFilter = true;
            if (this.colorSelected) {
              let res = altImagesToUse[i].altText
                .substring(altImagesToUse[i].altText.indexOf('Color:') + 6)
                .split(' - ');
              this.color = ':' + res[0] + ' -';
            }
          }
          if (!this.shouldFilter) {
            // console.log(i)
            this.altSlider.slickGoTo(i);
          }
        }
      }
    } else if (this.props.selectedMainImg && altImagesToUse) {
      for (i = 0; i < altImagesToUse.length; i++) {
        if (altImagesToUse[i].imageName === this.props.selectedMainImg) {
          if (this.props.contentData?.dept?.indexOf('00') == '00') {
            this.shouldFilter = true;
            if (this.colorSelected) {
              let res = altImagesToUse[i].altText
                .substring(altImagesToUse[i].altText.indexOf('Color:') + 6)
                .split(' - ');
              this.color = ':' + res[0] + ' -';
            }
          }
        }
      }
    }

    if (this.colorSelected && this.shouldFilter) {
      altImagesToUse = (altImagesToUse || []).filter((altImage) => altImage.altText.includes(this.color));
    }

    if (altImagesToUse && this.state.siteFormat == 'tablet') {
      if (
        this.props.contentData.productLayout == 'BundleDisplay' &&
        (altImagesToUse.length == 3 || altImagesToUse.length == 4)
      ) {
        this.shrinkButton = true;
      } else if (altImagesToUse.length == 4 && this.props.contentData.productLayout != 'QuickViewDisplay') {
        this.shrinkButton = true;
      }
    }

    const renameAltText = (altFromServer) => {
      let altTextArr = altFromServer.split(' - ');
      return `${this.props.contentData.brandNameForTitle} ${altTextArr[2]}, ${altTextArr[0].replace('Color: ', '')} - ${altTextArr[1]}`;
    };

    if (this.props.passedAppFunctions.siteFormat != 'desktop') {
      return this.props.contentData.altImages ? (
        <aside
          id='product-alt-wrapper'
          className={`${altImagesToUse.length < 4 ? 'bundleAltImages' : ''} ${settings.arrows ? 'has-arrows' : ''} ${this.state.showAlts ? '' : 'hide'}`}
        >
          {altImagesToUse && altImagesToUse.length > 3 ? (
            <Slider ref={(slider) => (this.altSlider = slider)} {...settings}>
              {altImagesToUse &&
                (altImagesToUse || []).map((altImage, index) => {
                  let src = `//dimg.dillards.com/is/image/DillardsZoom/alt/${this.props.contentData.fullImage.imageNameForUrl}/${
                    altImage.overideImageName || altImage.imageName
                  }.jpg`;
                  const mock = shouldMock(altImage.imageName);
                  if (mock) {
                    src = mock.alt;
                  }

                  return (
                    <button
                      manual_cm_sp={mock.cm_sp}
                      className='btn-tertiary'
                      key={altImage.imageName}
                      id={altImage.imageName}
                      data-key={index}
                      data-imagename={altImage.imageName}
                      onClick={(e) => this.props.passedFunctions.altImageClicked(e, mock)}
                      type='button'
                      data-role='none'
                      data-attrtype={this.props.passedFunctions.getAttrType(altImage.imageName, this.props.contentData)}
                      data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                      data-attrval={this.props.passedFunctions.getAttrName(altImage.imageName, this.props.contentData)}
                      aria-selected={
                        this.props.passedFunctions.parentState.selectedAttributeValue == altImage.altColor
                          ? 'true'
                          : null
                      }
                    >
                      <img
                        data-imagename={altImage.imageName}
                        data-val='here2'
                        src={src}
                        alt={renameAltText(altImage.altText)}
                        data-attrtype={this.props.passedFunctions.getAttrType(
                          altImage.imageName,
                          this.props.contentData
                        )}
                        data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                        data-attrval={this.props.passedFunctions.getAttrName(
                          altImage.imageName,
                          this.props.contentData
                        )}
                      />
                    </button>
                  );
                })}
            </Slider>
          ) : (
            altImagesToUse &&
            (altImagesToUse || []).map((altImage, index) => {
              let src = `//dimg.dillards.com/is/image/DillardsZoom/alt/${this.props.contentData.fullImage.imageNameForUrl}/${
                altImage.overideImageName || altImage.imageName
              }.jpg`;
              const mock = shouldMock(altImage.imageName);
              if (mock) {
                src = mock.alt;
              }
              return (
                <button
                  className={
                    !this.shrinkButton
                      ? 'btn-tertiary'
                      : this.props.contentData.productLayout == 'BundleDisplay'
                        ? 'btn-tertiary btn-mini'
                        : 'btn-tertiary btn-small'
                  }
                  manual_cm_sp={mock.cm_sp}
                  key={altImage.imageName + index}
                  id={altImage.imageName}
                  data-imagename={altImage.imageName}
                  data-key={index}
                  onClick={(e) => this.props.passedFunctions.altImageClicked(e, mock)}
                  type='button'
                  data-role='none'
                  data-attrtype={this.props.passedFunctions.getAttrType(altImage.imageName, this.props.contentData)}
                  data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                  data-attrval={this.props.passedFunctions.getAttrName(altImage.imageName, this.props.contentData)}
                  aria-selected={
                    this.props.passedFunctions.parentState.selectedAttributeValue == altImage.altColor ? 'true' : null
                  }
                >
                  <img
                    suppressHydrationWarning
                    src={src}
                    data-val='here3'
                    alt={renameAltText(altImage.altText)}
                    data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                    data-attrval={this.props.passedFunctions.getAttrName(altImage.imageName, this.props.contentData)}
                    data-attrtype={this.props.passedFunctions.getAttrType(altImage.imageName, this.props.contentData)}
                    className={
                      this.state.siteFormat == 'tablet' &&
                      this.props.contentData.productLayout == 'QuickViewDisplay' &&
                      altImagesToUse &&
                      altImagesToUse.length == 4
                        ? 'img-small'
                        : ''
                    }
                  />
                </button>
              );
            })
          )}
        </aside>
      ) : (
        ''
      );
    }

    return this.props.contentData.altImages ? (
      <aside
        id='product-alt-wrapper'
        className={`${settings.arrows ? 'has-arrows' : ''} ${this.state.showAlts ? '' : 'hide'}`}
      >
        {altImagesToUse &&
          altImagesToUse.length > 0 &&
          ((this.props.qvSlidesToShow > 0 && altImagesToUse.length > 4) ||
          this.state.siteFormat == 'tablet' ||
          this.state.siteFormat == 'mobile' ? (
            <Slider ref={(slider) => (this.altSlider = slider)} {...settings}>
              {altImagesToUse.map((altImage, index) => {
                let src = `//dimg.dillards.com/is/image/DillardsZoom/alt/${this.props.contentData.fullImage.imageNameForUrl}/${
                  altImage.overideImageName || altImage.imageName
                }.jpg`;
                const mock = shouldMock(altImage.imageName);
                if (mock) {
                  src = mock.alt;
                }
                return (
                  <button
                    manual_cm_sp={mock.cm_sp}
                    className='btn btn-tertiary btn-alt-img'
                    key={altImage.imageName + index}
                    data-key={index}
                    type='button'
                    data-role='none'
                    data-imagename={altImage.imageName}
                    data-attrtype={this.props.passedFunctions.getAttrType(altImage.imageName, this.props.contentData)}
                    data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                    data-attrval={this.props.passedFunctions.getAttrName(altImage.imageName, this.props.contentData)}
                    aria-selected={
                      this.props.passedFunctions.parentState.selectedAttributeValue == altImage.altColor ? 'true' : null
                    }
                    onClick={(e) => this.props.passedFunctions.altImageClicked(e, mock)}
                  >
                    <img
                      src={src}
                      alt={renameAltText(altImage.altText)}
                      height='102'
                      width='88'
                      data-attrtype={this.props.passedFunctions.getAttrType(altImage.imageName, this.props.contentData)}
                      data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                      data-attrval={this.props.passedFunctions.getAttrName(altImage.imageName, this.props.contentData)}
                    />
                  </button>
                );
              })}
            </Slider>
          ) : (
            <div className={altImagesToUse.length > 4 ? 'scrollAlts' : ''}>
              {altImagesToUse.map((altImage, index) => {
                let src = `//dimg.dillards.com/is/image/DillardsZoom/alt/${this.props.contentData.fullImage.imageNameForUrl}/${
                  altImage.overideImageName || altImage.imageName
                }.jpg`;
                const mock = shouldMock(altImage.imageName);
                if (mock) {
                  src = mock.alt;
                }

                return (
                  <button
                    manual_cm_sp={mock.cm_sp}
                    className={
                      'btn btn-tertiary btn-alt-img' +
                      (this.props.passedFunctions.parentState.selectedAttributeValue &&
                      this.props.passedFunctions.parentState.selectedAttributeValue == altImage.altColor
                        ? ' topAltImage'
                        : this.props.passedFunctions.parentState.selectedMainImg === altImage.imageName
                          ? ' topAltImage'
                          : '')
                    }
                    key={altImage.imageName + index}
                    type='button'
                    data-key={index}
                    data-role='none'
                    data-imagename={altImage.imageName}
                    data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                    data-attrval={this.props.passedFunctions.getAttrName(altImage.imageName, this.props.contentData)}
                    data-attrtype={this.props.passedFunctions.getAttrType(altImage.imageName, this.props.contentData)}
                    data-index={index}
                    aria-selected={
                      this.props.passedFunctions.parentState.selectedAttributeValue == altImage.altColor ? 'true' : null
                    }
                    onClick={(e) => this.props.passedFunctions.altImageClicked(e, mock)}
                  >
                    {index > 5 ? (
                      <img
                        src=''
                        className='lazy-altImage'
                        data-original={src}
                        alt={renameAltText(altImage.altText)}
                        height='102'
                        width='88'
                        data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                        data-attrtype={this.props.passedFunctions.getAttrType(
                          altImage.imageName,
                          this.props.contentData
                        )}
                        data-attrval={this.props.passedFunctions.getAttrName(
                          altImage.imageName,
                          this.props.contentData
                        )}
                      />
                    ) : (
                      <img
                        src={src}
                        alt={renameAltText(altImage.altText)}
                        height='102'
                        width='88'
                        data-attrtype={this.props.passedFunctions.getAttrType(
                          altImage.imageName,
                          this.props.contentData
                        )}
                        data-attrid={this.props.passedFunctions.getAttrId(altImage.imageName, this.props.contentData)}
                        data-attrval={this.props.passedFunctions.getAttrName(
                          altImage.imageName,
                          this.props.contentData
                        )}
                      />
                    )}
                  </button>
                );
              })}
            </div>
          ))}
      </aside>
    ) : (
      ''
    );
  }
}

class MainImageSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlts: false,
      siteFormat: this.props.passedAppFunctions ? this.props.passedAppFunctions.siteFormat : '',
      nav: null,
    };
  }
  componentDidMount() {
    this.setState({ showAlts: true });
    this.setState({ nav: this.altSlider });
    if (this.props.altClicked) {
      this.altWasClicked();
    }
  }

  componentDidUpdate() {
    this.slideMainImage(this.props.passedFunctions.parentState.selectedMainImg);
  }

  slideMainImage = (mainImageToSlideTo) => {
    if (!(this.colorSelected && this.shouldFilter)) {
      if (this.props.passedFunctions.parentState.productImagesArray?.length > 0) {
        this.props.passedFunctions.parentState.productImagesArray.forEach((alt, index) => {
          if (mainImageToSlideTo == alt.imageName) {
            this.slider1.slickGoTo(index);
          }
        });
      }
    } else {
      this.slider1.innerSlider.resizeWindow();
      for (var i = 0; i < this.slider1.props.children.length; i++) {
        if (mainImageToSlideTo == this.slider1.props.children[i].props.children.props['data-imagename']) {
          this.slider1.slickGoTo(i);
          break;
        }
      }
    }
  };

  altWasClicked = () => {
    this.slider1.slickGoTo(this.props.altIndex);
  };
  render() {
    this.color = '';
    this.colorSelected = false;
    this.shouldFilter = false;
    var altImagesToUse = this.props.passedFunctions.parentState.productImagesArray || [];

    if (this.props.passedFunctions.parentState.currentAttributeState?.Color?.attrName == 'Color') {
      if (this.props.passedFunctions.parentState.currentAttributeState.Color.selectedValue !== undefined) {
        this.colorSelected = true;
      }
    }

    if (this.slider1 && altImagesToUse) {
      for (var i = 0; i < altImagesToUse.length; i++) {
        if (altImagesToUse[i].imageName === this.props.selectedMainImg) {
          if (this.props.contentData?.dept?.indexOf('00') == '00') {
            this.shouldFilter = true;
            if (this.colorSelected) {
              let res = altImagesToUse[i].altText
                .substring(altImagesToUse[i].altText.indexOf('Color:') + 6)
                .split(' - ');
              this.color = ':' + res[0] + ' -';
            }
          }
        }
      }
    }

    var mainImgIndex = 0;
    if (
      this.props.passedAppFunctions.siteFormat == 'tablet' ||
      this.props.passedAppFunctions.siteFormat == 'mobile' ||
      this.props.contentData.productLayout == 'OutfitDisplay'
    ) {
      if (this.colorSelected && this.shouldFilter) {
        altImagesToUse = (altImagesToUse || []).filter((altImage) => altImage.altText.includes(this.color));
      }
      for (let i = 0; i < altImagesToUse.length; i++) {
        if (
          altImagesToUse[i].imageName ===
          (this.props.selectedMainImg || this.props.contentData.fullImage.imageNameNoPath)
        ) {
          mainImgIndex = i;
        }
      }
    }

    var settings = {
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      slidesToShow: 1,
      swipeToSlide: true,
      swipe: true,
      lazyLoad: true,
      lazyLoadBuffer: 1,
      initialSlide: mainImgIndex != undefined ? mainImgIndex : 0,
      arrows: false,
    };

    const renameAltText = (altFromServer) => {
      let altTextArr = altFromServer.split(' - ');
      return `${this.props.contentData.brandNameForTitle} ${altTextArr[2]}, ${altTextArr[0].replace('Color: ', '')} - ${altTextArr[1]}`;
    };

    return (
      <Slider
        className='main-img-wrapper-slider'
        openPhotoSwipeMain={this.props.openPhotoSwipeMain}
        ref={(slider) => (this.slider1 = slider)}
        {...settings}
      >
        {(altImagesToUse || []).map((altImage, index) => {
          const mock = shouldMock(altImage.imageName);
          if (mock) {
            return (
              <ProductMainVideo
                key={altImage.imageName + '__' + index}
                src={mock.video}
                poster={mock.poster}
                onShow={mock.onShow}
              />
            );
          }
          return (
            <div
              key={altImage.imageName + '__' + index}
              data-key={altImage?.dataKey}
              onClick={this.props.openPhotoSwipeMain}
            >
              <img
                src={`//dimg.dillards.com/is/image/DillardsZoom/mainProduct/${this.props.contentData.fullImage.imageNameForUrl}/${
                  altImage.overideImageName || altImage.imageName
                }.jpg`}
                alt={renameAltText(altImage.altText)}
                data-imagename={altImage.imageName}
              />
            </div>
          );
        })}
      </Slider>
    );
  }
}

export { AltImages, MainImageSlider };

export default AltImages;
